export default "__VITE_ASSET__hg6EHf$2__"